import React from 'react';
//@ts-ignore
import * as styles from './blog-breadcrumbs.module.css';
import { BlogBreadcrumbsProps } from './index';
import { getMultiChoice } from '../Global/DataUtils';
import Lotus from '../Global/Lotus';
import { IconNode } from '../Global/DataUtils/iconQueries';
import { navigate } from 'gatsby-link';
import LazyImage from '../Global/LazyImage';
import { prefixWithLang } from '../../global/countries';

interface Props extends BlogBreadcrumbsProps {
    icon?: IconNode;
    preferredLanguage?: string;
}

const BlogBreadcrumbs: React.FC<Props> = ({
    blog_home_page,
    blog_topic,
    headline,
    return_home_label,
    view_more_copy,
    icon,
    kontentItemId,
    preferredLanguage,
}) => {
    const blogHomePageUrl = prefixWithLang(
        blog_home_page.value[0]?.elements?.slug?.url || '',
        preferredLanguage
    );
    const blogHomePageNoFollow =
        getMultiChoice(blog_home_page.value[0]?.elements?.no_follow) === 'yes'
            ? 'nofollow'
            : undefined;
    const blogTopic = blog_topic?.value[0];
    const iconData = icon?.node?.elements?.icon_svg_file?.value[0];
    const iconColor = icon?.node?.elements?.color?.value[0]?.codename;
    const iconStyle =
        iconColor != 'dark_gray' ? { filter: 'grayscale(100%)' } : {};

    const renderLotus = () => {
        return (
            <div className={styles.icon}>
                <Lotus fillColor="#505251" heightWidth="1.25rem" />
            </div>
        );
    };

    const handleClickBlogTopic = (event: React.MouseEvent) => {
        event.preventDefault();
        navigate(blogHomePageUrl, {
            state: {
                filter: blogTopic,
            },
        });
    };

    return (
        <div className={styles.wrapper} data-kontent-item-id={kontentItemId}>
            <h2
                className={styles.title}
                data-kontent-element-codename="headline"
            >
                {headline.value}
            </h2>
            <ul className={styles.breadcrumbList}>
                {blogTopic && (
                    <li>
                        <a
                            href={`${blogHomePageUrl}`}
                            target="_self"
                            data-topic={blogTopic.codename}
                            onClick={handleClickBlogTopic}
                            data-kontent-element-codename="view_more_copy"
                        >
                            {iconData ? (
                                <object
                                    type="image/svg+xml"
                                    data={iconData.url}
                                    className={styles.icon}
                                    style={iconStyle}
                                >
                                    <LazyImage
                                        src={iconData.url}
                                        alt={iconData.description || ''}
                                        // SVG icon; parent .icon box is ~2rem.
                                        width={32}
                                        height={32}
                                    />
                                </object>
                            ) : (
                                renderLotus()
                            )}
                            {view_more_copy.value} {blogTopic.name}
                        </a>
                    </li>
                )}
                <li>
                    <a
                        href={blogHomePageUrl}
                        rel={blogHomePageNoFollow}
                        target="_self"
                        data-kontent-element-codename="return_home_label"
                    >
                        {renderLotus()}
                        {return_home_label.value}
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default BlogBreadcrumbs;
